import { Box, Modal, useMediaQuery } from '@mui/material'
import { Close } from '@mui/icons-material'
import InternetIcon from 'assets/svg/internet.svg'

import UserIcon from 'assets/svg/usericon.svg'

interface Props {
  isOpen: boolean
  handleVerifyFormOpen: any
  handleClose: any
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'fit-content',
}

export default function Welcome2({
  isOpen,
  handleVerifyFormOpen,
  handleClose,
}: Props) {
  const isonTabletOrMobile = useMediaQuery('(max-width: 768px)')

  const handleVerifyPayment = () => {
    handleClose()
    handleVerifyFormOpen()
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="flex flex-col w-[600px] max-md:w-[310px] max-md:px-[24px] max-md:pt-[56px] max-md:pb-[20px] rounded-[12px] p-[40px] pb-[48px] bg-[#201F34] relative text-white items-center select-none">
          <img
            className="w-[140px] h-[140px] mb-[8px] max-md:w-[98px] max-md:h-[98px] max-md:mb-[23px]"
            src={UserIcon}
            alt="User"
          />
          <h1 className="text-[32px] mb-[12px] text-center max-md:text-[20px] max-md:mb-[23px]">
            Welcome to KonectA!
          </h1>

          <p className="text-[16px] mb-[40px] text-[#BCBCC2] text-center max-md:text-[13px] max-md:mb-[23px]">
            To join Konecta, you&apos;ll need to fulfill one of the following
            requirements. Please select the option that works best for you.
          </p>
          <div className="w-full mx-[-24px] mb-[40px] h-[1.5px] bg-[#29283C] max-md:mb-[20px]" />
          <div className="flex gap-4 w-full">
            <button className="w-full bg-[#29283C] text-[16px] max-md:text-[13px] p-[19px] max-md:p-[12px] rounded-[11px]">
              Verified your unique person
            </button>
            <button
              className="w-full flex justify-center items-center gap-[6px] bg-[#337FF5] text-[16px] max-md:text-[13px] p-[19px] max-md:p-[12px] rounded-[11px]"
              onClick={handleVerifyPayment}
            >
              With Payment{' '}
              <img
                src={InternetIcon}
                alt="google"
                height={`${isonTabletOrMobile ? 18 : 25}`}
              />
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  )
}
